// Dashboard.jsx
import React, { useState, useEffect, useRef, useContext } from "react";
import { Box, Grid, Paper, Typography, Button, Divider } from "@mui/material";
import { SocketContext } from "../../context/SocketContext";
import TotalProtect from "./../../assets/img/logos/logoTPT.png";
import useCeo from "../../hooks/useCEO";
import {
  DataClient,
  GraficaEstatusEvento,
  GraficaEventMonth,
  GraficaEventosRiesgo,
  HorariosRobo,
  MapaEventos,
} from "../../components/Dashboards/EventoSeguridad";
import { useUnidades } from "../../hooks/test/useUnidades";
import { mesesCatalogo } from "./../../utils/catalogos";
import { Spinner } from "../../components/Spinner";
import { Spinner as Spin } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faChartColumn,
  faChartPie,
  faClockRotateLeft,
  faEarthAmericas,
  faUserSecret,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";
import { LoadingGraphs } from "../../components/Loader";

import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { es } from "date-fns/locale";

// Registrar locale
// registerLocale("es", es);

const fecha = new Date();
const diaActual = fecha.getDate().toString().padStart(2, '0');
const mesActual = String(mesesCatalogo[fecha.getMonth()].id).padStart(2, "0");
const anioActual = fecha.getFullYear();

export const DashboardSeguridad = () => {
  useCeo({
    title: "INDICADORES DE SEGURIDAD",
    description: "Página de indicadores de SWAT",
  });
  const { getStatsSwat } = useUnidades();
  const { socket } = useContext(SocketContext);

  const [loading, setLoading] = useState(false);
  const [detalle, setDetalle] = useState(false);
  const [data, setData] = useState([]);
  const [dataCompleta, setDataCompleta] = useState([]);
  const [horarios, setHorarios] = useState([]);
  const [conteo, setConteo] = useState({
    total: 0,
    count: [],
  });
  const [evento, setEvento] = useState([]);
  const [dataMonth, setDataMonth] = useState([]);
  const [tipoVehiculo, setTipoVehiculo] = useState(null);
  const [fechaI, setFechaI] = useState(`${anioActual}-${mesActual}-01`);
  const [fechaF, setFechaF] = useState(
    `${anioActual}-${mesActual}-${diaActual}`
  );
  const datePickerRef = useRef(null);

  const [range, setRange] = useState([
    new Date(anioActual, mesActual - 1, 1),
    new Date(anioActual, mesActual - 1, diaActual),
  ]);
  const [startDate, endDate] = range;

  useEffect(() => {
    const fetchSwat = async () => {
      try {
        setLoading(true);
        setData([]);
        setHorarios([]);
        setDataCompleta([]);
        setDataMonth([]);
        setEvento([]);
        setConteo({
          total: 0,
          count: [],
        });

        const resp = await getStatsSwat(fechaI, fechaF, tipoVehiculo);

        if (resp.ok && Array.isArray(resp.data)) {
          const array = resp.data.map((b) => {
            const fecha = b.fecha_hora ? new Date(b.fecha_hora) : null;
            return [
              b.tipo_unidad_id === 3
                ? "Motos"
                : b.tipo_unidad_id === 4
                ? "Autos"
                : "Camiones",
              b.unidad || "N/A",
              fecha ? format(fecha, "yyyy", { locale: es }) : "N/A",
              fecha ? format(fecha, "MMMM", { locale: es }) : "N/A",
              b.fecha_hora ? b.fecha_hora.substring(0, 10) : "N/A",
              b.entidad || "N/A",
              b.municipio || "N/A",
              b.evento_seguridad || "N/A",
              b.ultimo_estatus || "N/A",
            ];
          });

          setData(array);
          setHorarios(resp.horarios);
          setDataCompleta(resp.data);
          setDataMonth(resp.countMonth);
          setEvento(resp.totalEventos);
          setConteo({
            total: resp.total_eventos,
            pendientes: resp.total_pendientes,
            count: resp.count.map((item) => {
              let conViolencia = 0;
              let sinViolencia = 0;
              let otrosEventos = 0;

              item.eventos.forEach((evento) => {
                const nombre = evento.evento.toLowerCase();

                if (item.tipo_unidad === "Camiones") {
                  if (
                    nombre.includes("robo de transporte de carga con violencia")
                  )
                    conViolencia += evento.total_evento;
                  else if (
                    nombre.includes("robo de transporte de carga sin violencia")
                  )
                    sinViolencia += evento.total_evento;
                  else otrosEventos += evento.total_evento;
                } else if (item.tipo_unidad === "Autos") {
                  if (nombre.includes("robo de vehículo con violencia"))
                    conViolencia += evento.total_evento;
                  else if (nombre.includes("robo de vehículo sin violencia"))
                    sinViolencia += evento.total_evento;
                } else if (item.tipo_unidad === "Motos") {
                  if (nombre.includes("robo de motocicleta con violencia"))
                    conViolencia += evento.total_evento;
                  else if (nombre.includes("robo de motocicleta sin violencia"))
                    sinViolencia += evento.total_evento;
                }
              });

              return {
                tipo_unidad_id: item.tipo_unidad_id,
                tipo_unidad: item.tipo_unidad,
                total: item.total,
                robos: item.robos,
                recuperados: item.recuperados,
                boletinados: item.boletinados,
                recuperadas_porcentaje: item.recuperadas_porcentaje,
                boletinadas_porcentaje: item.boletinadas_porcentaje,
                eventos: item.eventos,
                conteo_eventos: {
                  con_violencia: conViolencia,
                  sin_violencia: sinViolencia,
                  otros_eventos: otrosEventos,
                },
              };
            }),
          });
        } else {
          setData([]);
          setHorarios([]);
          setDataCompleta([]);
          setDataMonth([]);
          setEvento([]);
          setConteo({
            total: 0,
            count: [],
          });
        }
      } catch (error) {
        console.error("Error al cargar eventos de seguridad:", error);
      } finally {
        setLoading(false);
      }
    };

    if (socket) {
      // Escucha múltiples eventos
      const eventos = ["new_event_robo_", "eventos_seguridad_"];
      eventos.forEach((ev) => socket.on(ev, fetchSwat));
    }

    // Llamar la primera vez
    fetchSwat();

    // Limpieza para evitar duplicados o fugas
    return () => {
      if (socket) {
        const eventos = ["new_event_robo_", "eventos_seguridad_"];
        eventos.forEach((ev) => socket.off(ev, fetchSwat));
      }
    };
  }, [fechaF, tipoVehiculo, socket]);

  const columns = [
    { name: "Tipo de unidad", label: "Tipo de unidad" },
    { name: "Unidad", label: "Unidad" },
    { name: "Año", label: "Año" },
    { name: "Mes", label: "Mes" },
    { name: "Fecha/Hora", label: "Fecha/Hora" },
    { name: "Entidad", label: "Entidad" },
    { name: "Municipio", label: "Municipio" },
    { name: "Evento", label: "Evento" },
    { name: "Ultimo Estatus", label: "Estatus" },
  ];

  const options = {
    selectableRows: "none",
    responsive: "standard",
    fixedHeader: true,
    downloadOptions: {
      filename: data ? `Bitácora de movimientos` : "Sin información",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true,
      },
      charset: "utf-8",
    },
    onDownload: (buildHead, buildBody, columns, data) =>
      "\uFEFF" + buildHead(columns) + buildBody(data),
    textLabels: {
      body: {
        noMatch: "No se encontraron registros",
        toolTip: "Ordenar",
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
      },
      pagination: {
        next: "Página siguiente",
        previous: "Página anterior",
        rowsPerPage: "Filas por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtro de tabla",
      },
      filter: { all: "TODOS", title: "FILTROS", reset: "LIMPIAR" },
      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Mostrar/Ocultar columnas de tabla",
      },
      selectedRows: {
        text: "Fila(s) seleccionada(s)",
        delete: "Remover",
        deleteAria: "Fila seleccionada removida",
      },
    },
  };

  const page = () => {
    if (detalle) {
      return (
        <>
          <Divider sx={{ mb: 3 }} />
          <div className="m-1">
            {loading && <Spinner />}
            <MUIDataTable
              title={loading ? "Cargando..." : `Eventos de seguridad`}
              data={data}
              columns={columns}
              options={options}
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <Divider sx={{ mb: 3 }} />
          {loading && <Spinner />}
          {data.length > 0 ? (
            <Grid container spacing={2}>
              {/* Gráficas o tablas (vacías por ahora) */}
              <Grid item xs={12} md={4}>
                <Paper
                  sx={{
                    p: 2,
                    height: "100%", // deja que el alto se adapte
                    minHeight: 340, // más alto para que entre el mapa + simbología
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "12px",
                    boxShadow: 6,
                    overflow: "hidden",
                    //   bgcolor: "#F8FAFC",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    //   sx={{
                    //     mb: 1.5,
                    //     display: "flex",
                    //     alignItems: "center",
                    //     color: "#1E293B",
                    //   }}
                  >
                    <FontAwesomeIcon
                      icon={faEarthAmericas}
                      className="text-primary"
                      style={{ marginRight: "8px", fontSize: "1.2rem" }}
                    />
                    &nbsp;Entidades con más eventos
                  </Typography>

                  {/* Contenedor del mapa */}
                  <Box
                    sx={{
                      flex: 1,
                      overflow: "hidden",
                      borderRadius: "8px",
                      backgroundColor: "white",
                      p: 1,
                    }}
                  >
                    {loading ? (
                      <LoadingGraphs />
                    ) : (
                      <MapaEventos data={dataCompleta} />
                    )}
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={12} md={4}>
                <Paper
                  sx={{
                    p: 2,
                    height: "100%", // deja que el alto se adapte
                    minHeight: 340, // más alto para que entre el mapa + simbología
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "12px",
                    boxShadow: 6,
                    overflow: "hidden",
                  }}
                >
                  <Typography variant="subtitle1" fontWeight="bold">
                    <FontAwesomeIcon
                      icon={faClockRotateLeft}
                      className="text-primary"
                      style={{ marginRight: "8px", fontSize: "1.2rem" }}
                    ></FontAwesomeIcon>
                    &nbsp;Horarios de eventos
                  </Typography>
                  <Box sx={{ flex: 1, overflow: "hidden" }}>
                    {loading ? (
                      <LoadingGraphs />
                    ) : (
                      <HorariosRobo data={horarios} />
                    )}
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={12} md={4}>
                <Paper
                  sx={{
                    p: 2,
                    height: "100%", // deja que el alto se adapte
                    minHeight: 340, // más alto para que entre el mapa + simbología
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "12px",
                    boxShadow: 6,
                    overflow: "hidden",
                  }}
                >
                  <Typography variant="subtitle1" fontWeight="bold">
                    <FontAwesomeIcon
                      icon={faChartPie}
                      className="text-primary"
                      style={{ marginRight: "8px", fontSize: "1.2rem" }}
                    ></FontAwesomeIcon>
                    &nbsp;Tipo de evento de riesgo
                  </Typography>
                  <Box sx={{ flex: 1, overflow: "hidden" }}>
                    {loading ? (
                      <LoadingGraphs />
                    ) : (
                      <GraficaEventosRiesgo conteo={conteo} />
                    )}
                  </Box>
                </Paper>
              </Grid>

              {/* Estatus por evento */}
              <Grid item xs={12} md={4}>
                <Paper
                  sx={{
                    p: 2,
                    height: "100%", // deja que el alto se adapte
                    minHeight: 340, // más alto para que entre el mapa + simbología
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "12px",
                    boxShadow: 6,
                    overflow: "hidden",
                  }}
                >
                  <Typography variant="subtitle1" fontWeight="bold">
                    <FontAwesomeIcon
                      icon={faUserSecret}
                      className="text-primary"
                      style={{ marginRight: "8px", fontSize: "1.2rem" }}
                    ></FontAwesomeIcon>
                    &nbsp; Estatus por robos
                  </Typography>
                  <Box sx={{ flex: 1, overflow: "hidden" }}>
                    {loading ? (
                      <LoadingGraphs />
                    ) : (
                      <GraficaEstatusEvento data={conteo.count} />
                    )}
                  </Box>
                </Paper>
              </Grid>

              {/* Número de unidades */}
              <Grid item xs={12} md={4}>
                <Paper
                  sx={{
                    p: 2,
                    height: "100%", // deja que el alto se adapte
                    minHeight: 340, // más alto para que entre el mapa + simbología
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "12px",
                    boxShadow: 6,
                    overflow: "hidden",
                  }}
                >
                  <Typography variant="subtitle1" fontWeight="bold">
                    <FontAwesomeIcon
                      icon={faChartColumn}
                      className="text-primary"
                      style={{ marginRight: "8px", fontSize: "1.2rem" }}
                    ></FontAwesomeIcon>
                    &nbsp;Número de unidades
                  </Typography>
                  <Box sx={{ flex: 1, overflow: "hidden" }}>
                    {loading ? (
                      <LoadingGraphs />
                    ) : (
                      <GraficaEventMonth data={dataMonth} />
                    )}
                  </Box>
                </Paper>
              </Grid>

              {/* Unidades por estado */}
              <Grid item xs={12} md={4}>
                <Paper
                  sx={{
                    p: 2,
                    height: "100%", // deja que el alto se adapte
                    minHeight: 340, // más alto para que entre el mapa + simbología
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "12px",
                    boxShadow: 6,
                    overflow: "hidden",
                  }}
                >
                  <Typography variant="subtitle1" fontWeight="bold">
                    <FontAwesomeIcon
                      icon={faUserTie}
                      className="text-primary"
                      style={{ marginRight: "8px", fontSize: "1.2rem" }}
                    ></FontAwesomeIcon>
                    &nbsp; Eventos por cliente
                  </Typography>
                  <Box sx={{ flex: 1, overflow: "hidden" }}>
                    {loading ? (
                      <LoadingGraphs />
                    ) : (
                      <DataClient data={dataCompleta} />
                    )}
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          ) : (
            <h3 className="text-center">No se encontraron registros</h3>
          )}
        </>
      );
    }
  };

  const handleClick = (tipoId) => {
    setTipoVehiculo(
      (prev) => (prev === tipoId ? null : tipoId) // si ya estaba seleccionado → reset (todos azules)
    );
  };

  const formatDate = (valor) => {
    if (!valor) return null;
    const year = valor.getFullYear();
    const month = String(valor.getMonth() + 1).padStart(2, "0");
    const day = String(valor.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleChange = (campo, valor) => {
    if (campo === "fechaI") setFechaI(formatDate(valor) || null);
    else setFechaF(formatDate(valor) || null);
  };

  const handleRangeChange = (update) => {
    const [start, end] = update;

    // Validación: no permitir que fechaF < fechaI
    if (start && end && end < start) return;

    setRange(update);

    if (start) handleChange("fechaI", start);
    if (end) handleChange("fechaF", end);

    // Solo cerrar el calendario si ambas fechas están seleccionadas
    if (start && end) {
      setTimeout(() => {
        datePickerRef.current?.setOpen(false);
      }, 200);
    }
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f5f5f5" }}>
      {/* Sidebar */}
      <Box
        sx={{
          width: { xs: "100%", sm: 200, md: 220 },
          bgcolor: "#e0e0e0",
          display: "flex",
          flexDirection: { xs: "row", sm: "column" },
          alignItems: "center",
          justifyContent: { xs: "space-around", sm: "flex-start" },
          py: { xs: 2, sm: 4 },
          boxShadow: 2,
          flexShrink: 0,
          flexWrap: "wrap",
        }}
      >
        <img
          src={TotalProtect}
          style={{ maxWidth: "120px", marginBottom: "1rem" }}
          alt="TotalProtect"
        />
        <Button
          onClick={() => setDetalle(false)}
          variant={!detalle ? "contained" : "outlined"}
          color="primary"
          sx={{ mb: { sm: 2 }, width: { xs: "40%", sm: "80%" } }}
        >
          Dashboard
        </Button>
        <Button
          onClick={() => setDetalle(true)}
          variant={detalle ? "contained" : "outlined"}
          sx={{ mb: { sm: 2 }, width: { xs: "40%", sm: "80%" } }}
        >
          Detalles
        </Button>
      </Box>

      {/* Main content */}
      <Box sx={{ flexGrow: 1, p: { xs: 2, md: 3 } }}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "center" },
            mb: 3,
            gap: 2,
          }}
        >
          <Typography
            variant="h8"
            sx={{
              fontWeight: "bold",
              color: "#1E293B", // gris oscuro elegante
              display: "flex",
              alignItems: "center",
              gap: 1, // espacio entre texto e icono
            }}
          >
            EVENTOS FINALIZADOS:&nbsp;
            <span style={{ color: "#0078FF" }}>
              {loading ? (
                <Spin size="sm" />
              ) : data.length === 0 ? (
                ""
              ) : tipoVehiculo ? (
                conteo.count.find((u) => u.tipo_unidad_id === tipoVehiculo)
                  ?.total
              ) : (
                conteo.total
              )}
            </span>{" "}
            <span style={{ color: "#0078FF" }}>
              {data.length === 0
                ? "Sin información"
                : tipoVehiculo === 1
                ? "Camiones"
                : tipoVehiculo === 3
                ? "Motos"
                : tipoVehiculo === 4
                ? "Autos"
                : "Unidades"}
            </span>
          </Typography>

          {/* Filters */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              width: "100%",
              justifyContent: { xs: "flex-start", md: "flex-end" },
            }}
          >
            <FontAwesomeIcon
              className="fa-2xl"
              onClick={() => datePickerRef.current?.setOpen(true)}
              icon={faCalendar}
            ></FontAwesomeIcon>

            <DatePicker
              ref={datePickerRef}
              selectsRange
              startDate={startDate}
              endDate={endDate}
              onChange={handleRangeChange}
              dateFormat="yyyy-MM-dd"
              locale="es"
              withPortal
              isClearable={false}
              shouldCloseOnSelect={false} // no se cierra al seleccionar solo una fecha
              maxDate={new Date()} // bloquea días futuros
              minDate={new Date(2024, 0, 1)} // 🔥 limita desde enero 2024
              customInput={<></>} // oculta el input
              showMonthDropdown // habilita selector de mes
              showYearDropdown // habilita selector de año
              dropdownMode="select" // los hace tipo dropdown
              scrollableYearDropdown // permite hacer scroll en años
              yearDropdownItemNumber={10} // muestra 10 años en la lista
            />
          </Box>
          <span>
            Del {fechaI} al {fechaF}
          </span>
        </Box>

        <Divider sx={{ mb: 3 }} />

        {/* GRID RESPONSIVO */}
        <Grid
          container
          spacing={2}
          sx={{
            flexWrap: "nowrap", // evita que se bajen
            justifyContent: "space-between", // distribuye uniformemente
            overflow: "hidden", // sin scroll horizontal
          }}
        >
          {[
            {
              color: "#007BFF",
              label: "Autos",
              tipoId: 4,
              total:
                evento.find((u) => u.tipo_unidad_id === 4)?.total_finalizados ??
                0,
            },
            {
              color: "#007BFF",
              label: "Camiones",
              tipoId: 1,
              total:
                evento.find((u) => u.tipo_unidad_id === 1)?.total_finalizados ??
                0,
            },
            {
              color: "#007BFF",
              label: "Motos",
              tipoId: 3,
              total:
                evento.find((u) => u.tipo_unidad_id === 3)?.total_finalizados ??
                0,
            },
            {
              color: "#FF0000",
              label: "Eventos de robo con violencia",
              total: conteo.count.reduce(
                (acc, item) => acc + item.conteo_eventos.con_violencia,
                0
              ),
            },
            {
              color: "#FFC129",
              label: "Eventos de robo sin violencia",
              total: conteo.count.reduce(
                (acc, item) => acc + item.conteo_eventos.sin_violencia,
                0
              ),
            },
            {
              color: "#FFDB00",
              label: "Eventos de riesgo",
              total: conteo.count.reduce(
                (acc, item) => acc + item.conteo_eventos.otros_eventos,
                0
              ),
            },
            {
              color: "#009688",
              label: "En seguimiento",
              total:
                data.length === 0
                  ? 0
                  : tipoVehiculo
                  ? evento.find((u) => u.tipo_unidad_id === tipoVehiculo)
                      ?.total_pendientes
                  : conteo.pendientes,
            },
          ].map((item, i) => {
            const bgColor = item.tipoId
              ? tipoVehiculo === null
                ? "#007BFF"
                : tipoVehiculo === item.tipoId
                ? "green"
                : "gray"
              : item.color;

            const textColor = ["#007BFF", "blue", "green", "#FF0000"].includes(
              bgColor
            )
              ? "white"
              : "black";

            return (
              <Grid
                item
                key={i}
                sx={{
                  flex: "1 1 13%", // reparte 7 iguales
                  minWidth: "140px", // asegura proporción
                  maxWidth: "14%",
                }}
              >
                <Paper
                  elevation={10}
                  onClick={
                    item.tipoId && !loading && item.total > 0
                      ? () => handleClick(item.tipoId)
                      : undefined
                  }
                  sx={{
                    borderRadius: "12px",
                    overflow: "hidden",
                    textAlign: "center",
                    height: "150px",
                    display: "flex",
                    flexDirection: "column",
                    cursor: item.tipoId ? "pointer" : "default",
                  }}
                >
                  <Box
                    sx={{
                      bgcolor: bgColor,
                      color: textColor,
                      flexGrow: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      px: 1,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" },
                      }}
                    >
                      {item.label}
                    </Typography>
                  </Box>

                  <Box sx={{ bgcolor: "white", py: 2 }}>
                    <Typography
                      variant="h4"
                      sx={{
                        color: "#0078FF",
                        fontWeight: "bold",
                        fontSize: { xs: "1.5rem", sm: "1.8rem" },
                      }}
                    >
                      {item.total}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
            );
          })}
        </Grid>

        {page()}
      </Box>
    </Box>
  );
};
